module.exports = __webpack_public_path__ + "img/kuraray_corporate_logo_rgb.fad93b25.svg";